import { StudentUsersUIProvider } from "./StudentUsersUIContext";
import { StudentUsersCard } from "./StudentUsersCard";

export function StudentUsersPage() {
  return (
    <StudentUsersUIProvider>
      <StudentUsersCard />
    </StudentUsersUIProvider>
 );
}